import { render, staticRenderFns } from "./ClosedProjectsIndex.vue?vue&type=template&id=efcd6ce2"
import script from "./ClosedProjectsIndex.vue?vue&type=script&lang=js"
export * from "./ClosedProjectsIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports